import axios from '@fs/zion-axios'
import { useCallback, useMemo, useState } from 'react'
import useFetchData from './useFetchData'
import { ContactIdAlreadyInUseError } from '../errors'
import throwUserProfileError from '../services/throwUserProfileError'

const profileUrl = '/service/user/profile/users/CURRENT'
const versionHeader = 'application/familysearch-user-profile+v1.1+json'

async function fetchProfile() {
  const { data } = await axios.get(profileUrl, {
    headers: {
      accept: versionHeader,
    },
  })
  return data
}

export default function useProfile() {
  const [refreshToken, setRefreshToken] = useState(0)
  const { data: remoteProfile, loading: profileLoading } = useFetchData(fetchProfile, { requestFnArg: refreshToken })
  const [localProfile, setLocalProfile] = useState(null)
  const profile = useMemo(() => ({ ...remoteProfile, ...localProfile }), [remoteProfile, localProfile])

  const invalidateProfileCache = useCallback(() => {
    setRefreshToken((t) => t + 1)
    setLocalProfile(null)
  }, [])
  const updateLocalProfile = useCallback((partial) => setLocalProfile((prev) => ({ ...prev, ...partial })), [])

  const handleChangeProfile = useCallback(async (newProfile) => {
    try {
      const response = await axios.post(profileUrl, newProfile, {
        headers: { 'Content-Type': 'application/json', accept: versionHeader },
      })
      setLocalProfile({ ...response.data })
    } catch (err) {
      if (err?.response?.data?.message?.includes('contactId is not available')) {
        throw new ContactIdAlreadyInUseError()
      }
      throwUserProfileError(err)
    }
  }, [])

  return {
    profile,
    // optimistically render if we can (so loading is only for initial fetch)
    profileLoading: refreshToken === 0 ? profileLoading : false,
    handleChangeProfile,
    invalidateProfileCache,
    updateLocalProfile,
  }
}
